import { Component } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaBriefcase } from 'react-icons/fa';
import Header from '../Header';
import Footer from '../Footer';
import Highlights from '../Highlights';
import Services from '../Services';
import TechStack from '../TechStack';
import './index.css';

class Home extends Component {
  render() {
    const skillTags = ['Full-Stack Dev', 'LLM & RAG', 'AI Agents', 'Python Teaching', 'Freelance Ready'];

    return (
      <div className="main-container">
        <Header />
        <section className="hero">
          <div className="hero-content">
            <p className="hero-badge">
              <span className="badge-pulse" />
              Open to Jobs, Internships & Freelance Work
            </p>
            <h1 className="hero-title">
              Full-Stack &amp;
              <span className="hero-gradient"> AI Developer</span>
              <br />
              who loves to teach
            </h1>
            <p className="hero-description">
              Hi, I&apos;m <strong>Naveen Janapati</strong> — B.Tech graduate (2026) from VVIT, Guntur.
              I build web apps and LLM-powered solutions, create Python educational content for 6,000+ followers,
              and bring 5 months of Chegg SME experience solving real computer science problems.
            </p>
            <div className="hero-tags">
              {skillTags.map((tag) => (
                <span key={tag} className="hero-tag">{tag}</span>
              ))}
            </div>
            <div className="hero-actions">
              <Link to="/contactme" className="btn-primary">
                <FaBriefcase />
                Hire Me
                <FaArrowRight />
              </Link>
              <Link to="/projects" className="btn-secondary">
                View Portfolio
              </Link>
            </div>
          </div>
          <div className="hero-visual">
            <div className="profile-ring" />
            <div className="profile-ring ring-2" />
            <img
              src="https://res.cloudinary.com/dmsebahwn/image/upload/v1735579457/profilepic_wpocch.jpg"
              alt="Naveen Janapati"
              className="profile-image"
            />
          </div>
        </section>

        <Highlights />
        <Services />
        <TechStack />
        <Footer />
      </div>
    );
  }
}

export default Home;
